var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#009C64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7955 8.30509C18.3562 7.86575 17.6438 7.86575 17.2045 8.30509L8.4545 17.0551C8.01517 17.4944 8.01517 18.2067 8.4545 18.6461C8.89384 19.0854 9.60616 19.0854 10.0455 18.6461L16.875 11.8166V26.7506C16.875 27.3719 17.3786 27.8756 18 27.8756C18.6213 27.8756 19.125 27.3719 19.125 26.7506V11.8165L25.9545 18.6461C26.3938 19.0854 27.1062 19.0854 27.5455 18.6461C27.9848 18.2067 27.9848 17.4944 27.5455 17.0551L18.7955 8.30509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.4924be2499eb752e3d6b4bc61f24810e.svg";
export { ForwardRef as ReactComponent };